import { render, staticRenderFns } from "./LiquidTabBar.vue?vue&type=template&id=ed1cbaca"
import script from "./LiquidTabBar.vue?vue&type=script&lang=js"
export * from "./LiquidTabBar.vue?vue&type=script&lang=js"
import style0 from "./LiquidTabBar.vue?vue&type=style&index=0&id=ed1cbaca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports